// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_Hh4","cls2":"AuthorPopover-cls2_xXu AuthorPopover-cls1_Hh4"};